import React, { useContext, useEffect, useState } from "react";
import "./mymeetings.css";
import UpcomingMeetings from "./UpcomingMeetings/UpcomingMeetings";
import PastMeetings from "./PastMeetings/PastMeetings";
import CancelledMeetings from "./CancelledMeetings/CancelledMeetings";
import { Url } from "../../../../constants/ApiUrlConstants";
import { POST } from "../../../Common/HttpMethods/HttpMethods";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useNavigate } from "react-router-dom";
// ------------------------------------------------------------------Icons-----------------------------------------------------------------
import {
  FaPlusSquare,
  FaCheck,
  FaChevronLeft,
  FaChevronRight,
  FaTimes,
  FaTrash,
  FaEdit,
  FaFilter,
  FaAngleDoubleLeft,
  FaAngleDoubleRight,
  FaMinus,
  FaSave,
  FaSearch,
  FaThList
} from "react-icons/fa";
import { contextData } from "../../../../context/ContextProvider";
import ViewPastMeetings from "./PastMeetings/ViewPastMeetings";
import AllMeetings from "./AllMeetings/AllMeetings";
import { createTableIcons, Cuurent_USER_ROLES, useRBAC } from "../../../CommonCase/CommonFunctions";

export const handleDateChange = (name, date,setSelectedToDate,setSelectedFromDate) => {
  if (name == "ToDate") {
    setSelectedToDate(date)
  }
  else {
    setSelectedFromDate(date)
  }
}


export const SvgDiv = (id) => {

  return (
    <span style={{ marginRight: "15px", display: "flex", padding: '5px 0px' }} data-testid="DatePickerId"
      onClick={() => { document.getElementById(id.DatePickerId == "1" ? "recEndDateFrom" : "recEndDate")?.click() }}
    >
      <svg
        id="calendar-line-icon"
        xmlns="http://www.w3.org/2000/svg"
        width="14px"
        height="14px"
        viewBox="0 0 27.119 27.122"
      >
        <path
          id="Path_15922"
          data-name="Path 15922"
          d="M18.011,1.044A1.176,1.176,0,0,1,19.285,0a1.176,1.176,0,0,1,1.273,1.044V5.617a1.176,1.176,0,0,1-1.273,1.044,1.176,1.176,0,0,1-1.273-1.044V1.044ZM14.59,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,14.807c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,18.859c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM6.535,1.044A1.176,1.176,0,0,1,7.808,0,1.176,1.176,0,0,1,9.082,1.044V5.617A1.176,1.176,0,0,1,7.808,6.661,1.176,1.176,0,0,1,6.535,5.617V1.044ZM1.412,10H25.7V4.738a.652.652,0,0,0-.19-.457.644.644,0,0,0-.457-.19H22.732a.706.706,0,0,1,0-1.412H25.06a2.065,2.065,0,0,1,2.059,2.059V25.062a2.065,2.065,0,0,1-2.059,2.059h-23A2.065,2.065,0,0,1,0,25.06V4.738A2.065,2.065,0,0,1,2.059,2.679H4.546a.706.706,0,1,1,0,1.412H2.059a.652.652,0,0,0-.457.19.644.644,0,0,0-.19.457V10Zm24.294,1.415H1.412V25.06a.652.652,0,0,0,.19.457.644.644,0,0,0,.457.19h23a.652.652,0,0,0,.457-.19.644.644,0,0,0,.19-.457V11.417ZM11.13,4.092a.706.706,0,0,1,0-1.412h4.743a.706.706,0,0,1,0,1.412Z"
          fill="#00aff1"
        />
      </svg>
    </span>
  )
}

export const navigateToSetupMeeting = (navigate, setActive) => {
  const roles = Cuurent_USER_ROLES();
  const isOrganizer = roles?.includes("QMS Organizer");

  if (isOrganizer) {
    navigate("/main/meetings/setupmeeting");
    setActive("tab2");
  }
};


export const getLengths = async ({
  selectedFromDate,
  selectedToDate,
  setMeetingLengths,
  POST,
  Url
}) => {
  let token = sessionStorage.getItem('TOKEN');

  let allMeetingsBody = {
    fromDate: moment(selectedFromDate).format('YYYY-MM-DD'),
    toDate: moment(selectedToDate).format('YYYY-MM-DD'),
    meetType: "Count",
  };

  try {
    let allmeetingsResp = await POST(Url.getAllTypeOfMeetingWithCount, token, allMeetingsBody);

    // Helper function to format the meeting count
    const formatCount = (count) => {
      return count === undefined || count === null ? "00" : count.toString().padStart(2, '0');
    };

    const allMeetingLength = formatCount(allmeetingsResp?.DATA?.allMeetingCnt);
    const upCommingMeetingLength = formatCount(allmeetingsResp?.DATA?.upcompingMeetingCnt);
    const pastMeetingLength = formatCount(allmeetingsResp?.DATA?.pastMeetingCnt);
    const canceledMeetingLength = formatCount(allmeetingsResp?.DATA?.cancelledMeetingCnt);

    setMeetingLengths((prevState) => ({
      ...prevState,
      all: allMeetingLength,
      upcomming: upCommingMeetingLength,
      past: pastMeetingLength,
      canceled: canceledMeetingLength,
    }));
  } catch (error) {
    console.log("Error in getting meeting count in my meetings", error);
    // Handle error gracefully
    setMeetingLengths({
      all: "00",
      upcomming: "00",
      past: "00",
      canceled: "00"
    });
  }
};


export const handleToDateChange = (selectedToDate, date, handleDateChange,setSelectedToDate,setSelectedFromDate) => {
  const selectedToTimestamp = selectedToDate && selectedToDate.getTime();
  const dateTimestamp = date && date.getTime();

  if (selectedToTimestamp !== dateTimestamp) {
    handleDateChange("ToDate", date,setSelectedToDate,setSelectedFromDate);
  }
};


const MyMeetings = () => {

  const { viewPastMeeting, setActive } = useContext(contextData);

  const navigate = useNavigate()

  // -------------------------------------------------------------------Data States--------------------------------------------------------
  const [currentTab, setCurrentTab] = useState("upcoming");
  const [upcomingMeetings, setUpcommingMeetings] = useState([]);
  const [selectedToDate, setSelectedToDate] = useState();
  const [selectedFromDate, setSelectedFromDate] = useState();
  const [selectedPeriod, setSelectedPeriod] = useState("Monthly");
  const [searchInp, setSearchInp] = useState("");
  const [toggleForCount, setToggleForCount] = useState(false);
  const cancelledData = [];
  const [meetinLlengths, setMeetingLengths] = useState({
    all: "00",
    upcomming: "00",
    past: "00",
    canceled: "00"
  })



  useEffect(() => {

  }, [meetinLlengths])

  // -------------------------------------------------------------------Boolean States-------------------------------------------------------
  const [openToDatePicker, setOpenToDatePicker] = useState(false);
  const [openFromDatePicker, setOpenFromDatePicker] = useState(false);
  const useCase = "QMS Calendar Integration";
  const rbac = useRBAC(useCase);
  const accessRoles = Cuurent_USER_ROLES();
  const AccRolesArr = accessRoles;



  
  useEffect(() => {

  }, [selectedPeriod])


  useEffect(() => {
    if (selectedToDate) {
      getLengths({
        selectedFromDate,
        selectedToDate,
        setMeetingLengths,
        POST,
        Url
      });
    }
  }, [selectedToDate, selectedFromDate, selectedPeriod, toggleForCount]);


  useEffect(() => {
    const previousMonthFirstDate = moment().subtract(1, 'months').startOf('month');
    const nextMonthLastDate = moment().add(1, 'months').endOf('month');

    const formattedPreviousMonthFirstDate = previousMonthFirstDate.format('YYYY-MM-DD');
    const formattedNextMonthLastDate = nextMonthLastDate.format('YYYY-MM-DD');

    setSelectedFromDate(new Date(formattedPreviousMonthFirstDate));
    setSelectedToDate(new Date(formattedNextMonthLastDate));
  }, []);

  // ------------------------------------------------------------Table Icons--------------------------------------------------------------

  const tableIcons = createTableIcons();

  return (
    <div className="my-meetings-container">
      {
        viewPastMeeting.isView ?
          <ViewPastMeetings />
          :
          <>
            <div className="select-period-container">

              <div style={{ display: "flex", alignItems: 'center', justifyContent: "flex-start" }}>
                <div
                  data-testid="containerDiv"
                  // onBlur={() => setTimeout(() => { setOpenFromDatePicker(false) }, 500)}
                  onClick={() => setOpenFromDatePicker(!openFromDatePicker)}
                  onBlur={() => setTimeout(() => { setOpenFromDatePicker(false) }, 500)}
                  style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", padding: "0px 8px 0px 6px" }}
                >
                  <label htmlFor="recEndDateFrom">From: </label>
                  <div style={{ width: "125px", display: "flex", justifyContent: "center", alignItems: "center", margin: "0 10px", border: "1px solid #B8B8B8", padding: "0px 0px 0px 5px", borderRadius: 4, color: "#B8B8B8", backgroundColor: "white" }}>
                    <SvgDiv DatePickerId={"1"} />
                    <DatePicker
                      id="recEndDateFrom"
                      name="recEndDate"
                      style={{ color: "#B8B8B8" }}
                      // open={openFromDatePicker}
                      showTimeSelect={false}
                      maxDate={selectedToDate}
                      selected={selectedFromDate}
                      onChange={(date) => {
                        const selectedFromTimestamp = selectedFromDate && selectedFromDate.getTime();
                        const dateTimestamp = date && date.getTime();

                        if (selectedFromTimestamp !== dateTimestamp) {
                          handleDateChange("FromDate", date,setSelectedToDate,setSelectedFromDate);
                        }
                      }}
                      dateFormat="dd/MM/yyyy"
                    />


                  </div>

                </div>
                <div
                  data-testid="containerDiv2"
                  // onBlur={() => setTimeout(() => { setOpenToDatePicker(false) }, 500)}
                  onClick={() => setOpenToDatePicker(!openToDatePicker)}
                  onBlur={() => setTimeout(() => { setOpenToDatePicker(false) }, 500)}
                  style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}
                >
                  <label htmlFor="recEndDate">To: </label>
                  <div style={{ width: "125px", display: "flex", justifyContent: "center", alignItems: "center", margin: "0 10px", border: "1px solid #B8B8B8", padding: "0px 0px 0px 5px", borderRadius: 4, color: "#B8B8B8", backgroundColor: "white" }}>
                    <SvgDiv DatePickerId={"2"} />
                    <DatePicker
                      id="recEndDate"
                      name="recEndDate"
                      style={{ color: "#B8B8B8" }}
                      // open={openToDatePicker}
                      minDate={selectedFromDate}
                      showTimeSelect={false}
                      selected={selectedToDate}
                      onChange={(date) => handleToDateChange(selectedToDate, date, handleDateChange,setSelectedToDate,setSelectedFromDate)}
                      dateFormat="dd/MM/yyyy"
                    />

                  </div>

                </div>
              </div>
              <div className="search-container">
                <div className="searchbox-container">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13.906px"
                    height="19.906"
                    viewBox="0 0 19.906 19.906"
                  >
                    <g
                      id="Icon_feather-search"
                      data-name="Icon feather-search"
                      transform="translate(1 1)"
                    >
                      <path
                        id="Path_2614"
                        data-name="Path 2614"
                        d="M20.049,12.274A7.774,7.774,0,1,1,12.274,4.5,7.774,7.774,0,0,1,20.049,12.274Z"
                        transform="translate(-4.5 -4.5)"
                        fill="none"
                        stroke="#afafaf"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      />
                      <path
                        id="Path_2615"
                        data-name="Path 2615"
                        d="M29.2,29.2l-4.227-4.227"
                        transform="translate(-11.71 -11.71)"
                        fill="none"
                        stroke="#afafaf"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      />
                    </g>
                  </svg>

                  <input className="my-meeting-search" type="search" placeholder="Search" data-testid="Search1" value={searchInp} onChange={(e) => { setSearchInp(e.target.value) }} />
                </div>

                {
                  AccRolesArr?.includes("QMS Organizer") &&
                  (
                    <button
                      className="create-meeting-btn"
                      type="button"
                      onClick={() => navigateToSetupMeeting(navigate, setActive)}
                    >
                      + Setup New Meeting
                    </button>

                  )
                }

              </div>
            </div>
            {/* <div style={{border:'1px solid red'}}> */}
            <div className="my-meetings-tabs">
              <ul className='meeting-summmary-nav-main'>
                <div className="starting-div" style={{ borderBottomRightRadius: currentTab == 'upcoming' ? "10px" : '0px', border: '1px solid rd !important' }}></div>
                <div className={"li-wraper"} >
                  <li className={currentTab == 'upcoming' ? 'mymeetings-active' : 'mymeetings-normal'} data-testid="currentTab1" onClick={() => { setCurrentTab('upcoming'); setSearchInp('') }}><div className={currentTab == 'upcoming' ? "Count-Type-cont" : ''}><span className="summary-info">Upcoming Meetings <span className={currentTab == 'upcoming' ? 'Activetab-countspan' : 'Normaltabs-countspan'}>{meetinLlengths?.upcomming}</span></span></div>

                  </li>
                </div>
                <div className={"li-wraper"} >
                  <li className={currentTab == 'past' ? 'mymeetings-active' : 'mymeetings-normal'} onClick={() => { setCurrentTab('past'); setSearchInp('') }}><div className={currentTab == 'past' ? "Count-Type-cont" : ''}><span className="summary-info">Past Meetings  <span className={currentTab == 'past' ? 'Activetab-countspan' : 'Normaltabs-countspan'}>{meetinLlengths?.past}</span></span></div>

                  </li>
                </div>
                <div className={"li-wraper"} >
                  <li className={currentTab == 'cancelled' ? 'mymeetings-active' : 'mymeetings-normal'} data-testid="currentTab3" onClick={() => { setCurrentTab('cancelled'); setSearchInp('') }}> <div className={currentTab == 'cancelled' ? "Count-Type-cont" : ''}><span className="summary-info">Cancelled Meetings  <span className={currentTab == 'cancelled' ? 'Activetab-countspan' : 'Normaltabs-countspan'}>{meetinLlengths?.canceled}</span></span></div>

                  </li>
                </div>
                <div className={"li-wraper"} >
                  <li className={currentTab == 'all' ? 'mymeetings-active' : 'mymeetings-normal'} data-testid="currentTab4" onClick={() => { setCurrentTab('all'); setSearchInp('') }}><div className={currentTab == 'all' ? "Count-Type-cont" : ''}><span className="summary-info">All Meetings  <span className={currentTab == 'all' ? 'Activetab-countspan' : 'Normaltabs-countspan'}>{meetinLlengths?.all}</span></span></div>

                  </li>
                </div>
                <div className="ending-div">

                </div>
              </ul>
            </div>
            <div className="meetings-data-container">
              {currentTab == "upcoming" ? (
                <UpcomingMeetings data={upcomingMeetings} selectedToDate={selectedToDate} selectedFromDate={selectedFromDate} selectedPeriod={selectedPeriod} searchInp={searchInp} toggleForCount={toggleForCount} setToggleForCount={setToggleForCount} />
              ) : currentTab == "past" ? (
                <PastMeetings tableIcons={tableIcons} selectedToDate={selectedToDate} selectedFromDate={selectedFromDate} selectedPeriod={selectedPeriod} searchInp={searchInp} toggleForCount={toggleForCount} setToggleForCount={setToggleForCount}></PastMeetings>
              ) : currentTab == "cancelled" ? (
                <CancelledMeetings data={cancelledData} selectedToDate={selectedToDate} selectedFromDate={selectedFromDate} selectedPeriod={selectedPeriod} searchInp={searchInp} toggleForCount={toggleForCount} setToggleForCount={setToggleForCount} />
              ) : <AllMeetings data={cancelledData} selectedToDate={selectedToDate} selectedFromDate={selectedFromDate} selectedPeriod={selectedPeriod} searchInp={searchInp} setSearchInp={setSearchInp} toggleForCount={toggleForCount} setToggleForCount={setToggleForCount} />}
            </div>
            {/* </div> */}
          </>

      }
    </div>
  );
};

export default MyMeetings;
